var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00355 0.995361C3.58139 0.995361 0 4.45024 0 8.70975C0 10.2441 0.466674 11.6741 1.26669 12.8752C1.29868 12.9122 1.35642 13.0128 1.39377 13.0792C1.47205 13.231 1.52175 13.4008 1.52175 13.585C1.52175 13.6542 0.775909 16.4848 0.775909 16.4848C0.72174 16.704 0.863857 16.9298 1.09243 16.9839C1.12621 16.9954 1.1591 16.9954 1.19288 16.9954C1.24705 16.9954 1.2969 16.9839 1.3466 16.9707L1.41416 16.9404L3.52357 15.8416C3.56092 15.8217 3.89872 15.6651 3.94037 15.647C4.08174 15.5873 4.24082 15.556 4.40792 15.556C4.55733 15.556 4.70391 15.5806 4.83726 15.631C4.84083 15.631 4.8453 15.631 4.8453 15.6357C4.86569 15.6472 4.88712 15.651 4.90839 15.6603C5.87108 16.0551 6.92614 16.1757 8.03911 16.1757C12.4586 16.1757 16 12.9713 16 8.71179C16.0055 4.44997 12.4241 0.995372 8.00368 0.995372L8.00355 0.995361ZM7.99998 13.3306C7.50934 13.3306 7.11113 12.9065 7.11113 12.3818C7.11113 11.8571 7.50934 11.433 7.99998 11.433C8.49328 11.433 8.88883 11.8571 8.88883 12.3818C8.88883 12.9065 8.49328 13.3306 7.99998 13.3306ZM8.88883 8.58653C8.88883 9.1112 8.49328 9.53535 7.99998 9.53535C7.50934 9.53535 7.11113 9.1112 7.11113 8.58653V4.7909C7.11113 4.26623 7.50934 3.84208 7.99998 3.84208C8.49328 3.84208 8.88883 4.26623 8.88883 4.7909V8.58653Z",
    fill: "url(#paint0_linear_15712_5856)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15712_5856",
    x1: 9.53455,
    y1: -5.63417,
    x2: -8.52812,
    y2: 5.14206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B83AF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.4b6397be.svg";
export { ForwardRef as ReactComponent };